import React from 'react'
import { CommonLogin } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'
import { CommonIntro } from './CommonIntro'

export const BavIntro = ({
  currentErrorRef: currentErrorRef,
  setProcessing: setProcessing,
  setError: setError,
  setErrorShown: setErrorShown
}) => {
  const { customerLogin, setCustomerLogin, getLoginUrl } = useApplicationContext()

  const smsLoginEnabled = process.env.SMS_LOGIN_ENABLED === 'true'
  const loginUrl = getLoginUrl()

  return (
    <CommonLogin
      currentErrorRef={currentErrorRef}
      setProcessing={setProcessing}
      setError={setError}
      setErrorShown={setErrorShown}
      customerLogin={customerLogin}
      setCustomerLogin={setCustomerLogin}
      loginUrl={loginUrl}
      smsLoginEnabled={smsLoginEnabled}
    >
      <h1 data-testid='welcome-heading' className={'text-4xl sm:text-5xl mb-2 leading-tight'}>
        Bank Account Verification
      </h1>
      <p>Welcome to Verifier — the privacy-friendly way to verify your bank account data.</p>
      <CommonIntro />
    </CommonLogin>
  )
}
